import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DyanamicClasses, IFieldEditStatus, InstanceLoader} from "@shared/helpers/dynamic-class-helper";
import {Router} from "@angular/router";
import {FieldDefinition} from "@shared/models/field-definition";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {
  DetailsInstructionService,
  InstructionDetailsSourceViewType
} from "@shared/services/details-instruction-service";
import {Configuration} from "@shared/models/configuration";
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {DialogService} from "@shared/services/dialog-service";

@Component({
    standalone: false,
    selector: 'particle-hallmark-question-cell-viewer',
  templateUrl: './hallmark-question-cell-viewer.component.html',
  styleUrls: ['./hallmark-question-cell-viewer.component.scss']
})
export class HallmarkQuestionCellViewerComponent implements OnInit, CellComponent {
  private _item: any;
  private _fieldDefinition: FieldDefinition;

  item: any;
  fieldDefinition: FieldDefinition;
  invalidateSubject?: InvalidateSubject;
  isEditable = true;
  sourceType: string;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  icon: string;
  disabled: boolean;
  constructor(private router: Router,
              private dialogService: DialogService,
              private detailsInstructionService: DetailsInstructionService) { }

  ngOnInit() {
    //console.log(this.item);
  }
  onClicked(action: string) {
    const editStatusAccessor = InstanceLoader.getInstance<IFieldEditStatus>(DyanamicClasses, 'HallmarkMxFieldEditStatusAccessor', this.item, this.fieldDefinition);
    this.isEditable = editStatusAccessor.isFieldEditable();
    if(this.isEditable){
      this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
    }
    else{
      const warningMessage = this.fieldDefinition.metaData['WarningMessage'] ? this.fieldDefinition.metaData['WarningMessage'] : `Values can be edited only if the corresponding Hallmark value is marked 'Yes'`;
      this.dialogService.showDialogMessage('Warning', warningMessage);
    }

    this.openDetailsPopUp(this.fieldDefinition);
  }

  openDetailsPopUp(fieldDefination: any) {
    const header = '<div style="margin-bottom: 20px;font-weight: bold;font-size: .95rem;">' +  fieldDefination['header'] + '</div>';
    const sourceType = Configuration.getBasketMappedSourceType(this.sourceType);
    const currentfieldKey = fieldDefination['key'];
    this.detailsInstructionService.getDetailsInstruction(InstructionDetailsSourceViewType.virtualGrid , sourceType, currentfieldKey).subscribe(data => {
      if (data) {
        const viewDetailObj = {};
        viewDetailObj['notes'] = header;
        if (data.details) {
          viewDetailObj['notes']  += data.details;
        }
        if (data.attachments) {
          viewDetailObj['attachments'] = data.attachments;
        }
        this.detailsInstructionService.setViewDetail(viewDetailObj);
      } else if (fieldDefination['fieldDetail']) {
        /*const detailMessage = fieldDefination['fieldDetail'];
         const fieldDetail = header + detailMessage;
         const viewDetailObj = {};
         viewDetailObj['notes'] = fieldDetail;
         this.detailsInstructionService.setViewDetail(viewDetailObj);*/
      } else {
        const detailMessage = '<p><strong>No additional details available.</strong></p>';
        const fieldDetail = header + detailMessage;
        const viewDetailObj = {};
        viewDetailObj['notes'] = fieldDetail;
        this.detailsInstructionService.setViewDetail(viewDetailObj);
        this.valueChanged.emit({fieldDefinition: fieldDefination, action: {id: 'OpenDetailsAndInstructions'}});
      }
    });
  }
}
